/**
 * Created by Marcus Zhao on 12/01/2020
 * -------------------------------------
 */

import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'tam-contact-divider',
    templateUrl: './contact-divider.component.html',
    styleUrls: ['./contact-divider.component.scss'],
    standalone: false
})
export class ContactDividerComponent implements OnInit {
    @Input() childConfig: any;
    constructor() { }

    ngOnInit() {
    }
}
